import React from "react";
import { Button, Card, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsArrowLeft, BsSearch } from "react-icons/bs";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";

const CardComponent = ({
  title,
  onclick,
  custom,
  align,
  link,
  classbody,
  className,
  shadow,
  headclass,
  heading2,
  children,
  icon,
  custom2,
  search,
  searchOnChange,
  target,
  tag,
  backButton = true,
  showBackButton = false,
  // Optional: when provided, the built-in back-arrow uses this instead of
  // history(-1). Lets pages return to an internal state (e.g. switch a tab
  // back to its list view) without leaving the URL. Backward compatible:
  // if not passed, original history(-1) behaviour is preserved.
  onBack,
  showCardHeader ,
}) => {
  const { t } = useTranslation();
  const history = useNavigate();
  const { id } = useParams();


  return (
    <Card className={`card-bg h-100 ${className}`}>
      {showCardHeader && (
      <Card.Header
        className={`${align} d-align d-md-flex gap-md-0 gap-2 d-grid justify-content-between bg-transparent border-primary p-3`}
        title={title}
      >
        <strong className={`d-align justify-content-between ${headclass}`}>
          {(id || showBackButton) && backButton ? (
            <BsArrowLeft
              title="back"
              fontSize={22}
              onClick={typeof onBack === "function" ? onBack : () => history(-1)}
              className="me-2 cursor-pointer"
            />
          ) : null}
          {t(title)} {heading2}
        </strong>{" "}
        <span className="d-align d-md-flex d-grid justify-content-between gap-2">
          {custom}
          {search && (
            <span className="position-relative">
              <BsSearch className="position-absolute top-50 me-3 end-0 translate-middle-y" />
              <Form.Control
                type="text"
                placeholder={t("Search")}
                onChange={searchOnChange}
                className="me-2"
                aria-label="Search"
              />
            </span>
          )}
          {tag && (
            <Button
              as={link ? Link : null}
              to={link}
              target={target}
              variant="light"
              className={`text-none view-btn shadow rounded-0 px-1 text-orange ${shadow}`}
              onClick={onclick}
            >
              {icon}
              {t(tag)}
            </Button>
          )}{" "}
          {custom2}
        </span>
      </Card.Header>
      )}
      {!showCardHeader && (
        <>
        {/* `backButton={false}` drops the arrow AND its strip, so a screen that
            does not want one (its own tabs sit at the top instead) is not left
            with an empty band pushing everything down. Defaults to true, so
            every existing caller is unchanged. */}
        {backButton && (
        <div className="ps-2 pt-2">
         <BsArrowLeft
         title="back"
         fontSize={22}
         onClick={typeof onBack === "function" ? onBack : () => history(-1)}
         className="me-2 cursor-pointer"
       />

       </div>
        )}

 <Card.Body className={classbody}>{children}</Card.Body>
 </>

      )}
      {showCardHeader && (
        <Card.Body className={classbody}>{children}</Card.Body>
      )}
    </Card>
  );
};

export default CardComponent;
